import { getFacilityCategoryIconComponent } from '@/utils/facility-category-icon';
import clsx from 'clsx';
import { useMemo } from 'react';
import styles from './styles.module.scss';

type Props = {
    clientCode: string;
    contrast: boolean;
    isHalfMode: boolean;
    size?: number;
    variant?: 'carousel' | 'modal';
};

const CAROUSEL_ICON_SIZE = 80;
const MODAL_ICON_SIZE = 160;
const FACILITY_ICON_COLOR = '#000000';

export const FacilityCategoryIcon = ({ clientCode, size, variant = 'carousel' }: Props) => {
    const IconComponent = useMemo(() => getFacilityCategoryIconComponent(clientCode), [clientCode]);
    const iconSize = useMemo(() => {
        if (size !== undefined) {
            return size;
        }
        return variant === 'modal' ? MODAL_ICON_SIZE : CAROUSEL_ICON_SIZE;
    }, [size, variant]);
    if (!IconComponent) {
        return (
            <div
                className={clsx(styles['facility-category-icon__skeleton'], 'animate-pulse', {
                    [styles['facility-category-icon__skeleton--modal']]: variant === 'modal',
                })}
                aria-hidden="true"
            />
        );
    }
    return (
        <div
            className={clsx(styles['facility-category-icon'], {
                [styles['facility-category-icon--modal']]: variant === 'modal',
            })}
        >
            <IconComponent width={iconSize} height={iconSize} color={FACILITY_ICON_COLOR} aria-hidden />
        </div>
    );
};
